"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocaleAction = exports.setLocale = exports.getLocalizationsUiAction = exports.getLocalizationsUi = exports.getLocalizationsAction = exports.getLocalizations = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @deprecated setLocale use setLocaleAction */
const setLocale = payload => ({
  type: types.SET_LOCALE,
  payload
});
/** @deprecated getLocalizations use getLocalizationsAction */
exports.setLocale = setLocale;
const getLocalizations = payload => ({
  type: types.GET_LOCALIZATIONS,
  payload
});
/** @deprecated getLocalizationsUi use getLocalizationsUiAction */
exports.getLocalizations = getLocalizations;
const getLocalizationsUi = payload => ({
  type: types.GET_LOCALIZATIONS_UI,
  payload
});
exports.getLocalizationsUi = getLocalizationsUi;
const setLocaleAction = payload => ({
  type: types.SET_LOCALE,
  payload
});
exports.setLocaleAction = setLocaleAction;
const getLocalizationsAction = payload => ({
  type: types.GET_LOCALIZATIONS,
  payload
});
exports.getLocalizationsAction = getLocalizationsAction;
const getLocalizationsUiAction = payload => ({
  type: types.GET_LOCALIZATIONS_UI,
  payload
});
exports.getLocalizationsUiAction = getLocalizationsUiAction;